import React from 'react';
import kfetch from '@kareo/kfetch';
import PropTypes from 'prop-types';
import rollbar from 'shared-assets/src/errors/errors';
import AssignModal from './AssignModal';
import UnrestrictedModal from './UnrestrictedModal';
import NoAssignModal from './NoAssignModal';
import { getAllUsersWithChartAccess } from '../../../service/accessControl/service';
import { getCachedDataContext } from '../../../utils/patientHelper';
import {
  CACHED_DATA_STATUS_CODE,
  DATE_CACHED_HTTP_HEADER,
} from '../../../service/facesheet/types';

const modalRoles = {
  ADMIN: 'ADMIN',
  CLIN: 'CLIN',
  PROVIDER: 'PROVIDER',
};
class ModalControl extends React.Component {
  constructor(props) {
    super(props);
    let legacyParams;
    if (this.props.match) {
      legacyParams = this.props.match.params;
      for (let key of Object.keys(legacyParams)) {
        if (legacyParams[key] === 'true') {
          legacyParams[key] = true;
        } else if (legacyParams[key] === 'false') {
          legacyParams[key] = false;
        }
      }
    }

    this.state = {
      assignModal:
        this.AssignCheck() ||
        (legacyParams && this.legacyAssignCheck(legacyParams)),
      noAssignModal:
        this.NoAssignCheck() ||
        (legacyParams && this.legacyNoAssignCheck(legacyParams)),
      legacyParams,
      isUsersWithChartAccessCached: false,
      usersWithChartAccessCachedDate: '',
    };
  }

  NoAssignCheck() {
    let isProviderOrClin =
      this.props.modalRolePath == modalRoles.PROVIDER ||
      this.props.modalRolePath == modalRoles.CLIN;
    let noAssign = this.props.patientRestricted && !this.props.userAccess;
    return isProviderOrClin && noAssign;
  }

  legacyNoAssignCheck(legacyParams) {
    let isProviderOrClin =
      legacyParams.modalRolePath == modalRoles.PROVIDER ||
      legacyParams.modalRolePath == modalRoles.CLIN;
    let noAssign = legacyParams.patientRestricted && !legacyParams.userAccess;
    return isProviderOrClin && noAssign;
  }

  AssignCheck() {
    let canProviderAssign =
      this.props.modalRolePath == modalRoles.PROVIDER &&
      !(this.props.patientRestricted && !this.props.userAccess);
    let assign =
      this.props.modalRolePath == modalRoles.ADMIN || canProviderAssign;
    return assign;
  }

  legacyAssignCheck(legacyParams) {
    let canProviderAssign =
      legacyParams.modalRolePath == modalRoles.PROVIDER &&
      !(legacyParams.patientRestricted && !legacyParams.userAccess);
    let canLegacyAssign =
      legacyParams.modalRolePath == modalRoles.ADMIN || canProviderAssign;
    return canLegacyAssign;
  }

  async getChartProtectionSettings(patientId) {
    return kfetch(
      `/facesheet-ui/api/Facesheet/access/restrictions/patient/${patientId}`,
    )
      .then(restrictions => {
        return restrictions;
      })
      .catch(e => {
        rollbar.error(e);
      });
  }

  getRestrictedList = async patientId => {
    try {
      const usersWithAccessResponse = await getAllUsersWithChartAccess(
        patientId,
      );
      if (usersWithAccessResponse?.ok) {
        if (usersWithAccessResponse?.status === CACHED_DATA_STATUS_CODE) {
          const cachedDate =
            usersWithAccessResponse.headers.get(DATE_CACHED_HTTP_HEADER) || '';
          this.setState({
            isUsersWithChartAccessCached: true,
            usersWithChartAccessCachedDate: cachedDate,
          });
        }
        return usersWithAccessResponse.json();
      }
    } catch (error) {
      rollbar.error(error);
    }
    return [];
  };

  getAllUsers = async () => {
    return kfetch(`/common-ui/api/User/getAllUsers`)
      .then(userList => {
        if (userList === undefined) {
          return [];
        }
        return this.filterUsers(userList);
      })
      .catch(e => {
        rollbar.error(e);
      });
  };

  filterUsers = userList => {
    return userList.filter(user => {
      return user.roles?.some(role => role == 2 || role == 4) && !user.isLocked;
    });
  };

  signalCloseModal() {
    let url =
      window.location != window.parent.location
        ? document.referrer
        : document.location.href;
    window.top.postMessage('close-modal', url);
  }

  handleClose = () => {
    const legacy = this.props.match && this.state.legacyParams.legacy;
    if (legacy) {
      this.signalCloseModal();
    } else {
      this.props.toggleModal();
    }
  };

  getUsersWithAccessCachedProps = () => {
    if (this.state.isUsersWithChartAccessCached) {
      return getCachedDataContext(this.state.usersWithChartAccessCachedDate);
    }
    return undefined;
  };

  render() {
    return (
      <Choose>
        <When condition={this.state.assignModal}>
          <AssignModal
            open={
              (this.props.match && this.state.legacyParams.open) ||
              this.props.open
            }
            restricted={
              this.props.patientRestricted ||
              (this.props.match && this.state.legacyParams.patientRestricted)
            }
            toggleRestriction={this.props.togglePatientRestriction}
            dataRestrictionEnabled={
              this.props.dataRestrictionEnabled ||
              (this.props.match &&
                this.state.legacyParams.dataRestrictionEnabled)
            }
            patientId={
              this.props.patientId ||
              (this.props.match && this.state.legacyParams.patientId)
            }
            legacy={this.props.match && this.state.legacyParams.legacy}
            getChartProtectionSettings={this.getChartProtectionSettings}
            getRestrictedList={this.getRestrictedList}
            getAllUsers={this.getAllUsers}
            handleClose={this.handleClose}
            firstName={
              this.props.firstName ||
              (this.props.match && this.state.legacyParams.firstName)
            }
            lastName={
              this.props.lastName ||
              (this.props.match && this.state.legacyParams.lastName)
            }
            modalRolePath={
              this.props.modalRolePath ||
              (this.props.match && this.state.legacyParams.modalRolePath)
            }
            cachedChartAccessContext={
              this.props.cachedChartAccessContext ||
              this.getUsersWithAccessCachedProps()
            }
          />
        </When>
        <When condition={this.state.noAssignModal}>
          <NoAssignModal
            open={
              (this.props.match && this.state.legacyParams.open) ||
              this.props.open
            }
            dataRestrictionEnabled={
              this.props.dataRestrictionEnabled ||
              (this.props.match &&
                this.state.legacyParams.dataRestrictionEnabled)
            }
            patientId={
              this.props.patientId ||
              (this.props.match && this.state.legacyParams.patientId)
            }
            legacy={this.props.match && this.state.legacyParams.legacy}
            getRestrictedList={this.getRestrictedList}
            getAllUsers={this.getAllUsers}
            handleClose={this.handleClose}
            firstName={
              this.props.firstName ||
              (this.props.match && this.state.legacyParams.firstName)
            }
            lastName={
              this.props.lastName ||
              (this.props.match && this.state.legacyParams.lastName)
            }
            cachedChartAccessContext={
              this.props.cachedChartAccessContext ||
              this.getUsersWithAccessCachedProps()
            }
          />
        </When>
        <Otherwise>
          <UnrestrictedModal
            open={
              (this.props.match && this.state.legacyParams.open) ||
              this.props.open
            }
            legacy={this.props.match && this.state.legacyParams.legacy}
            handleClose={this.handleClose}
            firstName={
              this.props.firstName ||
              (this.props.match && this.state.legacyParams.firstName)
            }
            lastName={
              this.props.lastName ||
              (this.props.match && this.state.legacyParams.lastName)
            }
            cachedChartAccessContext={this.props.cachedChartAccessContext}
          />
        </Otherwise>
      </Choose>
    );
  }
}

ModalControl.propTypes = {
  open: PropTypes.bool,
  modalRolePath: PropTypes.string,
  patientRestricted: PropTypes.bool,
  userAccess: PropTypes.bool,
  dataRestrictionEnabled: PropTypes.bool,
  patientId: PropTypes.number,
};

export default ModalControl;
